import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import Pill from '../Pill';

storiesOf('base', module).add('Pill', () => (
  <ScrollView>
    <Spacing size={20}>
      <Heading level={1}>Pill Component</Heading>
      <Spacer size={16} />
      <Text>
        This is the <Code>{'Pill'}</Code> component.
      </Text>
      <Spacer size={16} />
      <Text>
        By default the current user's competency level will be used to determine
        the primary button's background color.
      </Text>
      <Spacer size={16} />
      <FlexView>
        <Pill>Pill</Pill>
      </FlexView>
      <Spacer size={24} />
      <Heading level={2}>Overriding Competency Level</Heading>
      <Spacer size={16} />
      <Text>
        When the <Code>competency</Code> prop is set to a valid value it will
        override the current user's competency level and the corresponding
        background color for the button will be used instead.
      </Text>
      <Spacer size={16} />
      <FlexView>
        <Pill competency={COACH}>Pill for Coach</Pill>
        <Spacer size={6} />
        <Code>{'competency={COACH}'}</Code>
      </FlexView>
      <Spacer size={10} />
      <FlexView>
        <Pill competency={BUSINESS_COACH}>Pill for Business Coach</Pill>
        <Spacer size={6} />
        <Code>{'competency={BUSINESS_COACH}'}</Code>
      </FlexView>
      <Spacer size={10} />
      <FlexView>
        <Pill competency={BUSINESS_LEADER}>Pill for Business Leader</Pill>
        <Spacer size={6} />
        <Code>{'competency={BUSINESS_LEADER}'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
